import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { useEffect } from "react";

const MyInventory = () => {
  const [distributorList, setDistributorList] = useState("");

  useEffect(() => {
    getLisyInventory();
  }, []);

  const getLisyInventory = async () => {
    try {
      const res = await axios.get(
        `http://api.meddaily.in/distributor_get_product`,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (res.status === 200) {
        setDistributorList(res?.data?.product);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />

          <div className="layout-page">
            <Navbar />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card">
                    <h5 className="card-header float-start">Add New Product To Inventory</h5>
                    <div className="table-responsive text-nowrap">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>MFD Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                          {distributorList &&
                            distributorList.length > 0 &&
                            distributorList.map((dist, k) => [
                              <tr key={k}>
                                <td>
                                  <i className="fab fa-angular fa-lg text-danger me-3"></i>{" "}
                                  <strong>{dist.name}</strong>
                                </td>
                                <td>{dist.sub_title || "NA"}</td>
                                <td>
                                  <Link
                                    className="dropdown-item"
                                    // to="/distributordetails"
                                    to={{
                                      pathname: "/updateinv",
                                      // state: { id: dist._id },
                                      state: {
                                        productId: dist._id,
                                      },
                                    }}
                                  >
                                    {" "}
                                    Add
                                  </Link>
                                </td>
                              </tr>,
                            ])}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyInventory;
